/**
 * Centralised TanStack Query keys for the Categories resource. Sharing the
 * keys here keeps mutations and queries from drifting out of step when one is
 * invalidated and the other is read.
 */
export const CategoryQueryKeys = {
    all: ['categories'] as const,
    list: () => [...CategoryQueryKeys.all, 'list'] as const,
    details: () => [...CategoryQueryKeys.all, 'details'] as const,
    tree: () => [...CategoryQueryKeys.all, 'tree'] as const,
    picker: () => [...CategoryQueryKeys.all, 'picker'] as const,
    attributes: (categoryId: string) =>
        [...CategoryQueryKeys.all, 'attributes', categoryId] as const,
};
